export const validatePassword = (value: string) => {
		if (value.length === 0) {
			return "Password is required";
		}

		// Check if password contains at least one uppercase letter
		if (!/[A-Z]/.test(value)) {
			return "Password must contain at least one uppercase letter";
		}

		// Check if password contains at least one lowercase letter
		if (!/[a-z]/.test(value)) {
			return "Password must contain at least one lowercase letter";
		}

		// Check if password contains at least one number
		if (!/\d/.test(value)) {
			return "Password must contain at least one number";
		}

		// Check if password contains at least one special character
		if (!/[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]+/.test(value)) {
			return "Password must contain at least one special character";
		}

        if (value.length < 10) {
			return "Password must be at least 10 characters long";
		}

		return true;
	};